import React from "react"
import styles from "./TopTitle.module.scss"
import classnames from "classnames/bind"

const TopTitle = props => {
  let defaultStyles = [
    "proxima-nova--regular",
    "fs-30pt",
    props.textColor ? props.textColor : "text-secondary",
    props.removeBottomSpace ? null : "mb-3",
    "fs-xl-25pt",
  ]

  return (
    <div
      className={classnames(styles.container, defaultStyles, props.className)}
    >
      {props.content}
    </div>
  )
}

export default TopTitle
